import { FileWithPreview } from "@/interfaces/request.interface";
import { api } from "@/lib/api";
import { hideLoader, showLoader } from "@/store/slices/loaderSlice";
import { store } from "@/store/store";
import { BaseService } from "./base.service";
import { ApiResponse } from "@/interfaces/api.interface";
import { IRequestTasks, ITaskAction } from "@/interfaces/task.interface";
import ToastService from "@/utils/toast";

export class TaskService extends BaseService {
  constructor() {
    super("RequestTasks");
  }

  async uploadAttachments(taskId: string, files: FileWithPreview[]) {
    try {
      const formData = new FormData();

      formData.append("TaskId", taskId);
      files.forEach((file) => {
        // If we have a uniqueFile (renamed file), use that - otherwise fallback to original file
        const fileToUpload = file.uniqueFile || file;
        formData.append("Attachments", fileToUpload);
      });
      const res: any = await api.post(
        `${process.env.REACT_APP_BASE_URL}/api/RequestTasks/upload-attachments`,
        formData
      );
      if (res.ok) {
        if (res.data) {
          return { data: res.data, error: null };
        }
        return { data: null, error: res.data };
      }
      return { data: null, error: res.data };
    } catch (error) {
      return { data: null, error: error };
    } finally {
    }
  }

  async fetchTasksByRequestId(
    requestId: string
  ): Promise<ApiResponse<ITaskAction[]>> {
    try {
      const res: any = await api.get(
        `${process.env.REACT_APP_BASE_URL}/api/RequestTasks/by-requestId/${requestId}`
      );

      if (res.ok) {
        return {
          data: res.data,
          error: null,
        };
      }

      throw new Error(
        res.data?.message || "An error occurred while fetching areas"
      );
    } catch (error) {
      return {
        data: null,
        error: {
          message:
            (error as string) || "An error occurred while fetching areas",
        },
      };
    }
  }

  async taskAction(payload: ITaskAction): Promise<ApiResponse<ITaskAction>> {
    const res: any = await api.put(`/RequestTasks/task-action`, payload);

    if (res.data?.statusCode === 400 || res.data?.message) {
      ToastService.error(res.data.message);
      throw {
        response: {
          data: res.data,
          status: res.data.statusCode,
        },
      };
    }
    return { data: res.data as unknown as ITaskAction, error: null };
  }
}

export const tasksSvc = new TaskService();
